import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress, Tooltip, Menu, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import AddIcon from '@mui/icons-material/Add';
import SortIcon from '@mui/icons-material/Sort';
// Hình dạng dùng CHUNG với InputBase (ô tìm nhanh OTimNhanh, thanh dưới đáy) — xem giaoDienDanhSach.js.
import {
  sxOTimTrenTieuDe, sxIconTimTrenTieuDe, sxNutLocTrenTieuDe, sxNutThemTrenTieuDe,
  sxOTimDuoiDay, sxIconTimDuoiDay, sxNutVienDuoiDay, sxNutThemDuoiDay, sxKhungMenu, MAU_NHAN,
} from './giaoDienDanhSach';

export default function DataListActionBar({
  isHeaderMode = false,
  quickSearch,
  onQuickSearchChange,
  isLoading,
  onOpenFilter,
  canAdd,
  onAdd,
  
  // --- Props dành riêng cho chế độ Mobile/Tablet ---
  hideHeader,
  sortOptions,
  currentSort,
  onSortChange,
  actionBarPosition = 'bottom'
}) {
  const [sortAnchorEl, setSortAnchorEl] = useState(null);

  // ================= 1. GIAO DIỆN HEADER (DÀNH CHO PC) =================
  if (isHeaderMode) {
    return (
      <Box sx={{ display: 'flex', gap: 1, width: '100%', height: 32, alignItems: 'center' }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Tìm kiếm nhanh..."
          value={quickSearch}
          onChange={(e) => onQuickSearchChange(e.target.value)}
          slotProps={{
            input:{
              startAdornment: <SearchIcon sx={sxIconTimTrenTieuDe} />,
              endAdornment: isLoading && <CircularProgress size={14} sx={{ color: 'white' }} />
            }
          }}
          sx={sxOTimTrenTieuDe}
        />
        
        <Tooltip title="Bộ lọc nâng cao" placement="bottom">
          <Button variant="outlined" onClick={onOpenFilter} sx={sxNutLocTrenTieuDe}>
            <TuneIcon fontSize="small" />
          </Button>
        </Tooltip>
        
        {canAdd && (
          <Tooltip title="Thêm mới" placement="bottom">
            <Button variant="contained" onClick={onAdd} sx={sxNutThemTrenTieuDe}>
              <AddIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
      </Box>
    );
  }

  // ================= 2. GIAO DIỆN CHUẨN (DÀNH CHO MOBILE/TABLET) =================
  return (
    <Box sx={{
      display: 'flex', gap: 1.5, px: 2, 
      pt: actionBarPosition === 'bottom' ? 1.5 : 1,
      pb: actionBarPosition === 'bottom' ? 'max(16px, env(safe-area-inset-bottom))' : 1,
      bgcolor: 'white',
      borderTop: actionBarPosition === 'bottom' ? '1px solid #e5e5ea' : 'none',
      borderBottom: actionBarPosition === 'top' ? '1px solid #e5e5ea' : 'none',
      boxShadow: actionBarPosition === 'bottom' ? '0 -4px 20px rgba(0,0,0,0.03)' : 'none',
    }}>
      <TextField 
        fullWidth size="small" placeholder="Tìm kiếm nhanh..." 
        value={quickSearch} onChange={(e) => onQuickSearchChange(e.target.value)}
        slotProps={{
          input:{ 
            startAdornment: <SearchIcon sx={sxIconTimDuoiDay} />,
            endAdornment: isLoading && <CircularProgress size={16} /> 
          }
        }}
        sx={sxOTimDuoiDay} 
      />
      
      {/* Nút Sắp xếp phụ (Chỉ hiện khi Header chính bị ẩn) */}
      {hideHeader && sortOptions && sortOptions.length > 0 && (
        <>
          <Button variant="outlined" onClick={(e) => setSortAnchorEl(e.currentTarget)} sx={sxNutVienDuoiDay}>
            <SortIcon />
          </Button>
          <Menu anchorEl={sortAnchorEl} open={Boolean(sortAnchorEl)} onClose={() => setSortAnchorEl(null)} PaperProps={{ sx: sxKhungMenu }}>
            {sortOptions.map((opt, index) => (
              <MenuItem key={index} onClick={() => { onSortChange(opt); setSortAnchorEl(null); }} selected={currentSort?.label === opt.label} sx={{ fontWeight: currentSort?.label === opt.label ? 'bold' : 'normal', color: currentSort?.label === opt.label ? MAU_NHAN : 'inherit' }}>
                {opt.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
      
      <Button variant="outlined" onClick={onOpenFilter} sx={sxNutVienDuoiDay}>
        <TuneIcon />
      </Button>
      
      {canAdd && (
        <Button variant="contained" onClick={onAdd} sx={sxNutThemDuoiDay}>
          <AddIcon />
        </Button>
      )}
    </Box>
  );
}